import React from "react";
import Tabledata from "../modules/Screens/Tabledata";
export function DashboardPage() {
  return <Tabledata />;
}
